import React from "react";
import { I18n } from "react-redux-i18n";

import { getTestAttributes } from "@common/utils/tests";
import { Tabs } from "@common/components/tabs";
import { TextEditor } from "@common/components/text-editor";
import { turnOffSelectEvent, turnOnSelectEvent } from "@common/utils/ui/select-event";
import { MODULE_NAME } from "@modules/fhq-design-tool/constants/shared";
import { IInputComponent } from "@modules/fhq-design-tool/types/input-component";
import { Title } from "../../title";

import "./template.styles.scss";

type TemplateProps = IInputComponent<string> & {
  label?: string
}

export const Template = (props: TemplateProps) => {
  const TAB_TYPE = {
    html: "html",
    editor: "editor",

  };
  const { value = '', onChange, label, metadata } = props;
  const [currentTab, setCurrentTab] = React.useState(TAB_TYPE.editor);
  const localModuleName = `${MODULE_NAME}-configuration-template`;


  React.useEffect(() => {
    turnOffSelectEvent();

    return () => {
      turnOnSelectEvent();
    };
  }, []);

  const tabs = React.useMemo(() => {
    return [
      {
        ...getTestAttributes(localModuleName, "html-tab", "tab"),
        label: I18n.t("HTML"),
        value: TAB_TYPE.html,
      },
      {
        ...getTestAttributes(localModuleName, "editor-tab", "tab"),
        label: "EDITOR",
        value: TAB_TYPE.editor,
      },
    ];
  }, []);

  const [localValue, setLocalValue] = React.useState<string>('');

  React.useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLocalValue(e.target.value);
  }, []);

  const handleBlur = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  }, [onChange]);

  return (
    <div className="FhqDesignTool-template">
      {label && <Title margin="0" text={label} />}
      <Tabs
        value={currentTab}
        items={tabs}
        className="FhqDesignTool-template__tabs"
        onChange={setCurrentTab}
      />
      {currentTab === TAB_TYPE.editor && (
        <TextEditor
          classes={{
            workArea: "FhqDesignTool-template__editor__work-area",
          }}
          className="FhqDesignTool-template__editor"
          value={localValue}
          onBlur={onChange}
          toolbarCustomButtons={[]}
        />
      )}
      {currentTab === TAB_TYPE.html && (
        <textarea
          {...getTestAttributes(localModuleName, metadata.description, "editor", "textarea")}
          value={localValue}
          className="FhqDesignTool-template__html-textarea"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )}
    </div>
  );
};
